export default "__VITE_ASSET__a01f39c5__"